<script>
export default {
  inheritAttrs: false,

  props: {
    caption: {
      type: String,
      default: 'Table',
    },
    hover: {
      type: Boolean,
      default: false,
    },
    striped: {
      type: Boolean,
      default: false,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    select: {
      type: String,
      default: 'single',
    },
    fixed: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type: [Array, Function],
      default: () => [],
    },
    fields: {
      type: [Array, Object],
      default: () => [],
    },
    perPage: {
      type: Number,
      default: 7,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    rowSelected: {
      type: Function,
      default: () => {},
    },
  },

  data: () => {
    return {
      currentPage: 1,
    }
  },

  computed: {
    items: function() {
      const items = this.tableData ? this.tableData : []
      return Array.isArray(items) ? items : items()
    },
    totalRows: function() {
      return this.getRowCount()
    },
    captions: function() {
      return this.fields
    },
  },

  methods: {
    getBadge(status) {
      return status === 'Active'
        ? 'success'
        : status === 'Inactive'
        ? 'secondary'
        : status === 'Pending'
        ? 'warning'
        : status === 'Banned'
        ? 'danger'
        : 'primary'
    },
    getRowCount: function() {
      return this.items.length
    },
  },
}
</script>

<template>
  <b-card :header="caption">
    <b-table
      primary-key="id"
      :dark="dark"
      :hover="hover"
      :striped="striped"
      :bordered="bordered"
      :small="small"
      :fixed="fixed"
      responsive="sm"
      :items="items"
      :fields="captions"
      :current-page="currentPage"
      :per-page="perPage"
      selectable
      :select-mode="select"
      @row-selected="rowSelected"
    >
      <template slot="status" slot-scope="data">
        <b-badge :variant="getBadge(data.item.status)">{{ data.item.status }}</b-badge>
      </template>
    </b-table>
    <slot name="buttons"></slot>
    <nav>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        prev-text="Prev"
        next-text="Next"
        hide-goto-end-buttons
      />
    </nav>
  </b-card>
</template>

<style lang="scss">
@import '@design';
.table-primary > td {
  color: $dark !important;
  background-color: $primary !important;
}
table th,
table tr,
table td {
  border-top: 1px solid #343b41 !important;
}
.table thead th {
  border-bottom: 0 !important;
}
.table thead > tr {
  border-top: 0 !important;
}
.table > thead > tr > th {
  border-top: 0 !important;
}
</style>
